import { useContext } from 'react';
import { Title2 } from '@fluentui/react-components';
import { SignInContext } from '@modules/users';

const PageHeader = () => {
  const { organization } = useContext(SignInContext);

  return (
    <div className="flex flex-col gap-1 items-start justify-between mb-8 max-w-3xl">
      <Title2>Welcome back, {organization.name}!</Title2>
    </div>
  );
};

export default PageHeader;
